
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...action]]",
      function () {
        return require("private-next-pages/[[...action]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...action]]"])
      });
    }
  